<template>
    <gofix-card v-if="$checkRole($accessModule.order_tabs.work_findings, 'read')" :title="cardTitle" class="mb-0 cardChild" classContent="mb-0">
        <template slot="gofixCard:right_header">
            <template v-if="isList">
                <template v-if="!IsReadOnly">
                    <gofix-button v-if="permission.create" label=" " @click="storageItem(null, 'edit')" noBorder>
                        <template slot="gofix:button:beforeLabel">
                            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                            </svg>
                        </template>
                    </gofix-button>
                </template>
            </template>
            <template v-else>
                <button class="icon-button" v-if="!IsReadOnly && permission.create" @click="storageItem(null, 'edit')"><img width="20" src="img/iconPencil.png" alt="" /></button>
            </template>
        </template>
        <b-row no-gutters class="mb-15">
            <template v-for="(item, index) in listing">
                <b-col :md="isList ? 4 : 12" :class="[{'pr-15 mb-10': isList}]" :key="index">
                    <gofix-card title=" " :class="['h-100', {'pd-15': isList, 'cardNoBox': !isList}]" classHeader="pt-0 mb-0" classContent="mb-0 pl-0 pr-0">
                        <b-row>
                            <b-col :md="isList ? 9 : 12" class="mb-15">
                                <gofix-text-field classLabel="min-width-auto" label="Description" oneline>
                                    <span v-html="item.description ? item.description.replaceAll('\n', '<br>') : ''"></span>
                                </gofix-text-field>
                            </b-col>
                            <b-col md="3" class="mb-15 text-right" v-if="isList">
                                <template v-if="!IsReadOnly">
                                    <span v-if="permission.update" class="editBox position-static cursor-pointer mr-12" @click="storageItem(item, 'edit')">
                                        <img src="img/iconPencil.png" alt  width="18" height="18"/>
                                    </span>
                                    <span v-if="permission.delete" class="editBox position-static cursor-pointer" @click="storageItem(item, 'delete')">
                                        <img src="img/deleteIcon.png" alt  width="20" height="20"/>
                                    </span>
                                </template>
                            </b-col>
                            <b-col md="5" class="photosThumb mt-0">
                                <gofix-text-field classLabel="min-width-auto" label="photos" oneline>
                                    <template v-if="item.attachments">
                                        <viewer-image :images="item.attachments" classViewer='d-flex align-items-center'>
                                            <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                                <ul class="list-thumb checklist">
                                                    <template v-for="(item, key) in images">
                                                        <li v-if="key < limitImage" :class="{'d-none': images.length > limitImage && key >= ((limitImage - 1) ? (limitImage - 1) : 1)}" v-bind:key="key">
                                                            <img :alt="item.image_file_name" :key="item.url.original" v-auth-image="item.url.original"  src="img/loading.gif">
                                                        </li>
                                                    </template>
                                                </ul>
                                                <template v-if="images.length > limitImage">
                                                    <div class="attachmentsColumn cursor-pointer pl-0">
                                                        <div class="item-content bg-transparent pd-0">
                                                            <img class="image-viewer" v-auth-image="images[images.length-1].url.original" src="img/loading.gif">
                                                            <span class="checklist-photo-custom" v-if="images.length > limitImage">+{{ images.length - limitImage }}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>
                                        </viewer-image>
                                    </template>
                                </gofix-text-field>
                            </b-col>
                        </b-row>
                    </gofix-card>
                </b-col>
            </template>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="cardTitle" hide-footer :centered="true" v-model="modal.edit.open">
            <b-form class="pb-10">
                <gofix-form-input-textarea label="Description" :rows="5" v-model="service_report.description"></gofix-form-input-textarea>
                <b-form-group label="photos" class="photosThumb clear-both">
                    <ul class="list-thumb">
                        <li v-for="(item,key) in service_report.attachments" v-bind:key="key">
                            <img v-auth-image="item.url.thumb" src="img/loading.gif" alt />
                            <span class="delete" @click="deleteimgServiceReport(item)">
                                <img src="img/close.png" alt />
                            </span>
                        </li>
                    </ul>
                    <div class="upload-btn-wrapper">
                        <b-form-file accept="image/jpeg, image/png, image/gif" id="fileInputMulti" v-model="imgServiceReport" :plain="true" :multiple="true"></b-form-file>
                        <gofix-button class="m-3" label="add photo" outline></gofix-button>
                    </div>
                </b-form-group>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SAVE" @click="saveItem" :loading="isAction" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modal.delete.open">
            <div class="center">Are you sure you want to<br/>delete <strong>This Item</strong>?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modal.delete.open = false">No</b-button>
                <b-button class="custom-btn" :disabled="modal.delete.loading" @click="deleteItem"> <b-spinner v-if="modal.delete.loading" small type="grow"></b-spinner> Yes</b-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>

<script>
    import { mapGetters } from 'vuex';
    const ViewerImage = () => import('../../plugins/ViewerImage.vue')
    import moment from 'moment';
    export default {
        name: 'service-report-wf-and-at',
        components: {
            ViewerImage,
        },
        props: {
            cardTitle: {
                type: String,
                default: ''
            },
            isList: {
                type: Boolean,
                default: true
            },
            work_finding_action_taken_group_id: {
                type: Number
            },
            moduleRole: {
                type: String,
                default: 'service_report'
            },
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return{
                isAction: false,
                limitImage: 2,
                imgServiceReport: null,
                imgServiceReportAction: {
                    photos: [],
                    delete: [],
                },
                service_report_del_ids: [],
                service_report: {},
                timer: {
                    edit: null,
                    delete: null
                },
                modal: {
                    edit: {
                        open: false,
                        loading: false
                    },
                    delete: {
                        open: false,
                        loading: false
                    }
                },
                listing: [],
                api: {
                    work_finding: 'order-work-finding',
                    action_taken: 'order-action-taken',
                }
            }
        },

        computed: {
            ...mapGetters({
                Item: 'OrderController/Item',
                Loading: "OrderServiceReportController/Loading",
                IsReadOnly: 'OrderController/IsReadOnly',
            }),
            permission() {
                return {
                    create: this.$checkRole(this.$accessModule.order_tabs[this.moduleRole], 'create'),
                    update: this.$checkRole(this.$accessModule.order_tabs[this.moduleRole], 'update'),
                    delete: this.$checkRole(this.$accessModule.order_tabs[this.moduleRole], 'delete'),
                }
            }
        },
        mounted() {
            this.$nextTick(function () {
                window.addEventListener('resize', this.handleResize);
            })
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
        created() {
            this.handleResize();
            if(this.Item && this.Item.id)
                this.getItems();
        },
        watch: {
            imgServiceReport(val, old) {
                if (val) {
                    val.forEach((file) => {
                        if (
                            file.type != "image/jpeg" &&
                            file.type != "image/png" &&
                            file.type != "image/gif"
                        ) {
                            this.$alertNotification("File format is incorrect. Please select a .jpeg, .jpg, .png, .gif file!", "warning");
                            return;
                        }
                        file.moment = moment().valueOf();
                        let data = {
                            moment: moment().valueOf(),
                            url: {
                                original: URL.createObjectURL(file),
                                medium: URL.createObjectURL(file),
                                thumb: URL.createObjectURL(file),
                            },
                        };

                        this.imgServiceReportAction.photos.push(file);
                        this.service_report.attachments.push(data);
                    });
                }
            }
        },
        methods: {
            handleResize() {
                this.limitImage = 2
                if (window.innerWidth < 1920) {
                    this.limitImage = 1
                }
            },
            /* --- Work Finding --- */
            getItems() {
                this.$store.dispatch("OrderServiceReportController/getItems", {
                    isCMS: false,
                    filter: {
                        order_id: this.Item.id,
                        work_finding_action_taken_group_id: this.work_finding_action_taken_group_id
                    },
                    api: this.api[this.type]
                }).then(response => {
                    let items = response.items
                    if(!this.isList && this.type == 'action_taken' && !items.length) {
                        items = [
                            {
                                attachments: [],
                                description: null,
                                id: null,
                            }
                        ]
                    }
                    
                    this.listing = items
                })
            },
            storageItem(item, action = null) {
                this.isAction             = false;
                this.modal.edit.loading   = false;
                this.modal.delete.loading = false;

                this.service_report_del_ids = [];
                this.imgServiceReportAction.photos = [];

                if(!this.isList && !item && this.listing.length) {
                    item = this.listing[0]
                }
                
                if(item && item.id) {
                    this.service_report = {
                        id: item.id,
                        order_id: this.Item.id,
                        description: item.description ? item.description : '',
                        attachments: item.attachments ? JSON.parse(JSON.stringify(item.attachments)) : [],
                        work_finding_action_taken_group_id: this.work_finding_action_taken_group_id
                    };
                } else {
                    this.service_report = {
                        order_id: this.Item.id,
                        description: null,
                        attachments: [],
                        work_finding_action_taken_group_id: this.work_finding_action_taken_group_id
                    }
                }

                if(action == 'edit') this.modal.edit.open = true;
                if(action == 'delete') this.modal.delete.open = true;
            },
            saveItem() {
                if (this.timer.edit) {
                    clearTimeout(this.timer.edit);
                    this.timer.edit = null;
                }
                this.timer.edit = setTimeout(() => {
                    if (this.isAction) return;

                    this.isAction = true;
                    this.$store
                        .dispatch("OrderServiceReportController/saveItem", {
                            data:   this.service_report,
                            photos: this.imgServiceReportAction.photos,
                            api: this.api[this.type]
                        })
                        .then(async (result) => {

                            this.imgServiceReportAction = {
                                photos: [],
                                delete: [],
                            };

                            if(this.service_report_del_ids.length > 0) {
                                await this.$store.dispatch("OrderServiceReportController/deleteAttachments", { ids : this.service_report_del_ids } )
                                .then(result => {
                                  this.service_report_del_ids = [];
                                })
                            }

                            await this.getItems();
                            this.modal.edit.open    = false;
                            this.modal.edit.loading = false;
                            this.$alertNotification(this.$notificationV2(this.service_report.id ? "editing" : "adding", this.type == 'work_finding' ? "job_work_finding" : "action_taken"));
                        })
                        .catch(error => {
                            this.modal.edit.loading = false;
                            this.isAction = false;
                            console.log(error);
                        });
                }, 100)
            },
            deleteItem() {
                if(!this.service_report.id) return;
                if (this.timer.delete) {
                    clearTimeout(this.timer.delete);
                    this.timer.delete = null;
                }
                this.timer.delete = setTimeout(() => {
                    this.modal.delete.loading = true;
                    this.$store.dispatch('OrderServiceReportController/deleteItem', {
                        ids: [this.service_report.id],
                        order_id: this.Item.id,
                        work_finding_action_taken_group_id: this.work_finding_action_taken_group_id,
                        api: this.api[this.type]
                    })
                    .then(response => {
                        this.modal.delete.open    = false;
                        this.modal.delete.loading = false;
                        this.modal.edit.open      = false;
                        this.getItems();
                        this.$alertNotification(this.$notificationV2('deleting', 'job_work_finding'));
                    })
                    .catch(error => {
                        this.modal.delete.loading = false;
                        console.log(error);
                    });
                }, 100)
            },
            deleteimgServiceReport(img) {
                if (img.moment) {
                    this.service_report.attachments = this.service_report.attachments.filter(
                        (item) => item.moment != img.moment
                    );
                    this.imgServiceReportAction.photos = this.imgServiceReportAction.photos.filter(
                        (item) => item.moment != img.moment
                    );
                } else {
                    this.service_report_del_ids.push(img.id);
                    this.service_report.attachments = this.service_report.attachments.filter(
                        (item) => item.id != img.id
                    );
                }
            }
        }
    }
</script>
<style lang="scss">
    .gofixCard  {
        &.cardChild {
            .gofixCardHeader {
                h3 {
                    &.title {
                        padding-left: 0;
                    }
                }
            }
        }
    }
</style>
